import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoutesAPI,
  getRoutesAssignedAPI,
} from "../../../../services/rest/routes/routesServices";
import {
  setlistRoutes,
  setListRoutesAssigned,
} from "../../../../redux/slice/routeSlice";
import { BarChart } from "@mui/x-charts";
import { Box } from "@mui/material";
import toast from "react-hot-toast";
import { filterRoutesOfMembership } from "../../../../utils/FilterRoutesOfMembership";

const RunnerStats = () => {
  const { listRoutes, listRoutesAssigned } = useSelector(
    (state) => state.routeReducer
  );
  const { _id, status } = useSelector((state) => state.userReducer);
  const { membershipStatus, lastPayment, nextPayment } = useSelector(
    (state) => state.membershipReducer
  );
  const dispatch = useDispatch();
  const getRoutes = async () => {
    try {
      const routes = await getRoutesAPI(_id);
      const routesAssigned = await getRoutesAssignedAPI();

      dispatch(
        setListRoutesAssigned({ listRoutesAssigned: routesAssigned ?? [] })
      );
      const totalRoutes = [...routes, ...routesAssigned];
      const routesOfMembership = filterRoutesOfMembership(
        { paymentDate: lastPayment, expiresDateMembership: nextPayment },
        totalRoutes ?? []
      );
      // console.log("Rutas de la membresía:", routesOfMembership);

      dispatch(
        setlistRoutes({
          listRoutes: routes ?? [],
          totalOfRoutesMembership: routesOfMembership ?? 0,
        })
      );
    } catch (error) {
      toast.error("No pudimos recuperar sus rutas.  \n Intentelo más tarde.");
    }
  };
  useEffect(() => {
    if (status === "active" || membershipStatus === "active") {
      getRoutes();
    }
  }, []);
  const { stats } = formatDataRoutes(
    [...listRoutes, ...listRoutesAssigned] ?? []
  );
  const xAxisData = ["1-3 KM", "3-5 KM", "5+ KM"];
  const seriesData = [
    {
      label: "Completas",
      data: xAxisData.map((category) => stats[category].completa),
    },
    {
      label: "Incompletas",
      data: xAxisData.map((category) => stats[category].incompleta),
    },
    {
      label: "Sin Iniciar",
      data: xAxisData.map((category) => stats[category].creada),
    },
  ];
  return (
    <Box sx={{ justifyContent: "center", display: "flex" }}>
      {/* Gráfico de pastel */}

      <BarChart
        xAxis={[{ scaleType: "band", data: xAxisData }]}
        series={seriesData}
        height={350}
      />
    </Box>
  );
};

export default RunnerStats;

const formatDataRoutes = (routes) => {
  const stats = {
    "1-3 KM": { completa: 0, incompleta: 0, creada: 0 },
    "3-5 KM": { completa: 0, incompleta: 0, creada: 0 },
    "5+ KM": { completa: 0, incompleta: 0, creada: 0 },
  };
  routes.forEach((route) => {
    const distance = route.distance; // distancia en metros
    const distanceKm = distance / 1000; // convertir a kilómetros
    let status;

    if (route.status === "completa") {
      status = "completa";
    } else if (route.status === "incompleta") {
      status = "incompleta";
    } else {
      status = "creada"; // Asumimos que cualquier otro estado es "en proceso"
    }

    if (distanceKm <= 3) {
      stats["1-3 KM"][status]++;
    } else if (distanceKm <= 5) {
      stats["3-5 KM"][status]++;
    } else {
      stats["5+ KM"][status]++;
    }
  });
  return { stats };
};
